import { useCallback, useContext, useLayoutEffect, useState } from "react"
import { UploadDocumentsContext } from "../../UploadDocuments"


export default function useUploadDocumentFormPayload(){

    const context = useContext(UploadDocumentsContext)

    const {
        id,
        invoiceData,
        submitHandler,
    } = context ?? {}

    const{
        canInsert,
    } = useContext(UploadDocumentsContext)

    const [payload, setPayload] = useState([])

    const initializePayload = useCallback(() => {
        setPayload([])
    }, [setPayload])

    useLayoutEffect(() => initializePayload?.(), [initializePayload])

    const handleChangeFile = useCallback((e) => {
        setPayload(e)
    }, [setPayload])

    const onSubmit = useCallback(() => {
        const formData = new FormData()

        payload.forEach((item) => {
            formData.append("attachments[]", item.file);
        });

        submitHandler?.(id, formData)
    }, [submitHandler, payload])

    return {
        invoiceData,
        canInsert,
        payload, setPayload,
        handleChangeFile,
        onSubmit,
    }
}